// ======================================================================
// FILE:
// src/modules/service_crm/installed_products/components/InstalledProductsTable.js
//
// MODULE: Service CRM
// FEATURE: Installed Products Table
// ======================================================================

import React from "react";

import { useNavigate } from "react-router-dom";

export default function InstalledProductsTable({
  rows = [],
  loading = false,
  hasFilters = false,
}) {

  const navigate = useNavigate();

  // -------------------------------------------------------------------
  // STATUS BADGE
  // -------------------------------------------------------------------
  const renderStatusBadge = (status) => {

    const value = (status || "").toLowerCase();

    let background = "#6c757d";

    if (value === "commissioned") {
      background = "#198754";
    }

    else if (value === "pending") {
      background = "#fd7e14";
    }

    else if (value === "rejected") {
      background = "#dc3545";
    }

    return (

      <span
        style={{
          background,

          color: "#fff",

          padding: "4px 10px",

          borderRadius: 20,

          fontSize: 12,

          fontWeight: 600,
        }}
      >
        {status || "N/A"}
      </span>
    );
  };

  // -------------------------------------------------------------------
  // LOADING
  // -------------------------------------------------------------------
  if (loading) {

    return (

      <div
        style={{
          background: "#fff",

          borderRadius: 14,

          padding: 40,

          textAlign: "center",

          boxShadow:
            "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        Loading installed products...
      </div>
    );
  }

  // -------------------------------------------------------------------
  // EMPTY
  // -------------------------------------------------------------------
  if (!rows.length) {

    return (

      <div
        style={{
          background: "#fff",

          borderRadius: 14,

          padding: 40,

          textAlign: "center",

          boxShadow:
            "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >

        <div
          style={{
            fontSize: 18,

            fontWeight: 600,

            marginBottom: 8,
          }}
        >
          No Installed Products Found
        </div>

        <div
          style={{
            color: "#6c757d",
          }}
        >
          {hasFilters
            ? "Try changing search or filters."
            : "No products available yet."}
        </div>

      </div>
    );
  }

  // -------------------------------------------------------------------
  // TABLE
  // -------------------------------------------------------------------
  return (

    <div
      style={{
        background: "#fff",

        borderRadius: 14,

        padding: 16,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

        overflowX: "auto",

        marginBottom: 20,
      }}
    >

      <table
        className="table table-hover align-middle"
      >

        <thead>

          <tr>

            <th>Instance ID</th>

            <th>Customer</th>

            <th>Contact</th>

            <th>Engine Serial</th>

            <th>KVA</th>

            <th>State</th>

            <th>City</th>

            <th>Commissioning</th>

            <th>Running Hours</th>

            <th width="220">
              Actions
            </th>

          </tr>

        </thead>

        <tbody>

          {rows.map((row) => (

            <tr
              key={row.id}
            >

              {/* INSTANCE */}
              <td>
                <strong>
                  {row.instance_id}
                </strong>
              </td>

              {/* CUSTOMER */}
              <td>
                {row.customer_name || "-"}
              </td>

              {/* CONTACT */}
              <td>
                {row.contact_number || "-"}
              </td>

              {/* ENGINE SERIAL */}
              <td>
                {row.engine_serial_no || "-"}
              </td>

              {/* KVA */}
              <td>
                {row.kva_rating || "-"}
              </td>

              {/* STATE */}
              <td>
                {row.state || "-"}
              </td>

              {/* CITY */}
              <td>
                {row.city || "-"}
              </td>

              {/* STATUS */}
              <td>
                {renderStatusBadge(
                  row.commissioning_status
                )}
              </td>

              {/* RUNNING HOURS */}
              <td>
                {row.running_hours || 0}
              </td>

              {/* ACTIONS */}
              <td>

                <div
                  style={{
                    display: "flex",

                    gap: 8,

                    flexWrap: "wrap",
                  }}
                >

                  {/* VIEW */}
                  <button
                    className="btn btn-sm btn-outline-primary"

                    onClick={() =>
                      navigate(
                        `/service-crm/installed-products/${row.id}`
                      )
                    }
                  >
                    View
                  </button>

                  {/* EDIT */}
                  <button
                    className="btn btn-sm btn-outline-success"

                    onClick={() =>
                      navigate(
                        `/service-crm/installed-products/${row.id}/edit`
                      )
                    }
                  >
                    Edit
                  </button>

                  {/* CREATE TICKET */}
                  <button
                    className="btn btn-sm btn-outline-warning"

                    onClick={() =>
                      navigate(
                        `/service-crm/tickets/create?product_id=${row.id}`
                      )
                    }
                  >
                    Create Ticket
                  </button>

                </div>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}